"use strict";

/**
* @ngdoc service
* @name nms.templates.DeviceOptionsExtractionService
* @description
* # Serviço para extração de opções.
* Factory in the nms.templates.
*/
var app = angular.module("nms.templates");

app.factory("DeviceOptionsExtractionService", ["RestDeviceOptionsExtractionService", "$q",
    function(RestDeviceOptionsExtractionService, $q) {
        const service: any = {};

        service.testExtraction = function(input, extractionParams) {
            var request: any = {
                input: input,
                ruleOptions: extractionParams.extractOptionsFilterResults ? extractionParams.ruleOptions : [],
                rulesMatchingMode: extractionParams.rulesMatchingMode,
                regexToExtractOptions: extractionParams.extractResultsFromCliResults
                    ? extractionParams.regexToExtractOptions : "",
                specificOccurrences: extractionParams.useSpecificOccurrences ? extractionParams.specificOccurrences : "",
                transformationLogicCommands: extractionParams.hasTransformationLogic
                    ? extractionParams.transformationLogicCommands : ""
            };

            return RestDeviceOptionsExtractionService.testOptionsExtraction(request);
        };

        service.extractDeviceOptions = function (deviceId, templateId, allVariablesValues, variablesIgnoredOnExtraction) {
            var request: any = {
                deviceId: deviceId,
                templateId: templateId,
                commandTemplateVariables: allVariablesValues,
                variablesIgnoredOnExtraction: variablesIgnoredOnExtraction
            };
            return RestDeviceOptionsExtractionService.extractDeviceOptions(request);
        };

        service.extractSpecificVariableOptions = function(deviceId, templateId, variableName,
                selectedAction, allVariablesValues) {
            var request: any = {
                deviceId: deviceId,
                templateId: templateId,
                variableName: variableName,
                selectedAction: selectedAction,
                commandTemplateVariables: allVariablesValues
            };

            return RestDeviceOptionsExtractionService.extractSpecificVariableOptions(request);
        };

        return service;
    }
]);
